// flow weak

import React, {
    PureComponent,
     useState, useEffect 
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import AnimatedView           from '../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import ReactTable from "react-table"; 
  import { Link }         from 'react-router-dom';

  
  
  class AppDownloads extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue: props.props.statsTable.revenue_per_month.requested_venue_id,
        details:[],

        
      };
      
    }
  
    componentDidMount() {
        this.getDetails();
    }

    locationChanged() {
    this.setState({venue:this.props.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getDetails()  
    })
    }


    getDetails(){
     const url = `${getLocationOrigin()}/cm/get_app_downloads/?venue=${this.state.venue}`;
     const options = {...defaultOptions};
     console.log('get calls')

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({details:data.result});
           // alert("fix");
       }).catch(error => error);
    }

    

    connectCall(call) {
      console.log('call')
      console.log(call)
      const url = `${getLocationOrigin()}/calls/connect_customer/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                          'customer_no': call.mobile_no,
                                          'source':'CM'
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){                     
            alert(response.message);
            // props.history.goBack();
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    callBack(id) {
      var call = this.state.details.find(temp => temp.customer_id_hidden == id)
      this.connectCall(call)
    }

   

    getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  
    render() {
      console.log('amount')
      console.log(this.state.details) 
      const data = this.state.details;

      if(this.state.venue != this.props.props.statsTable.revenue_per_month.requested_venue_id){
        this.locationChanged()
      }

      const dialog_ok = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleAudioClose}
        />
      ];
      

      const columns = [
       {  
       Header: 'Created On',  
       accessor: 'created_on'
       },{  
       Header: 'Customer',  
       accessor: 'name',
       Cell: ({row}) => (<span>{row.name ? row.name:'-'}</span>),  
       },{  
       Header: 'Mobile Number',  
       accessor: 'mobile_no',
       minWidth: 100,
       Cell: cellInfo => (<a target="_blank" href={"/#/crud/customerDetails/"+cellInfo.original.customer_id_hidden}>{cellInfo.original.mobile_no}</a>)
       },{  
       Header: 'Venue',  
       accessor: 'venue'  
       },{
       Header: 'Action',
       accessor: 'customer_id_hidden',
       maxWidth: 70,
       Cell: ({row}) => (<span onClick={()=>this.callBack(row.customer_id_hidden)} className='badge badge-default' style={{cursor:'pointer',backgroundColor:'#32CD32',color:'white'}}><i className='fa fa-phone fa-2x'></i></span>)
       }
       ];

       
      return(
        <div className="col-md-12 row">

          <div className="col-md-12 table-bordered" style={{marginTop:'10px',marginLeft:'15px'}}>
           
            <ReactTable  
                    data={data}  
                    className="-striped -highlight"
                    columns={columns}  
                    defaultPageSize = {100}  
                    pageSizeOptions = {[100,200,500]} 
                    filterable={true}
                    showPagination={data.length > 100}
                    showPaginationTop = {data.length > 100}
                    style = {{background:'#9370DB'}}
                    getTrProps = {this.getTrProps}
                    defaultFilterMethod = {(filter, row, column) => {
                      const id = filter.pivotId || filter.id
                      return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                    }}
                   
            >

              {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid">
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }

            </ReactTable>

          </div>

          
        </div>

          
        
      );
    }
  }
  
  export default AppDownloads;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/appDownloads/AppDownloads.js